<app-loading *ngIf="!contentReady"></app-loading>

<div class="container dentist-form-page mb-4" *ngIf="contentReady" dir="rtl" lang="ar">
  <div class="row additem-content">
    <h2 class="additemhead">
      {{ isUpdatePage ? 'تعديل تسجيل طبيب الأسنان' : 'تسجيل طبيب أسنان جديد' }}
    </h2>

    <form
      class="form dentist-form"
      [formGroup]="data"
      (ngSubmit)="onSubmit()"
      enctype="multipart/form-data"
      novalidate
    >
      <div class="d-flex flex-column flex-sm-row justify-content-center">
        <div class="col-12 form-container">

          <!-- صورة الطبيب -->
          <div class="form-group full-row">
            <label class="field-label">صورة الطبيب</label>

            <input
              #doctorImageInput
              type="file"
              class="real-file-input"
              accept="image/png,image/jpeg,image/jpg"
              (change)="onDoctorImageSelected($event)"
            />

            <div class="custom-file-box" (click)="doctorImageInput.click()">
              <button type="button" class="file-btn">
                اختيار صورة
              </button>

              <span class="file-name">
                {{ selectedDoctorImage ? selectedDoctorImage.name : 'لم يتم اختيار صورة' }}
              </span>
            </div>

            <small class="hint" *ngIf="isUpdatePage && existingDoctorImage">
              توجد صورة مرفوعة حاليًا
            </small>
          </div>

          <!-- الاسم بالكامل -->
          <div class="form-group">
            <label class="field-label">الاسم بالكامل <span>*</span></label>
            <input
              class="input"
              type="text"
              formControlName="full_name"
              placeholder="اكتب الاسم بالكامل"
            />
            <small class="error-text" *ngIf="isInvalid('full_name')">
              الاسم بالكامل مطلوب
            </small>
          </div>

          <!-- تاريخ الميلاد -->
          <div class="form-group">
            <label class="field-label">تاريخ الميلاد</label>
            <input
              class="input"
              type="date"
              formControlName="date_of_birth"
            />
          </div>

          <!-- النوع -->
          <div class="form-group">
            <label class="field-label">النوع</label>
            <select class="input" formControlName="gender">
              <option value="">اختر النوع</option>
              <option value="male">ذكر</option>
              <option value="female">أنثى</option>
            </select>
          </div>

          <!-- رقم الموبايل -->
          <div class="form-group" *ngIf="!isUpdatePage">
            <label class="field-label">رقم الموبايل</label>
            <input
              class="input"
              type="text"
              formControlName="mobile"
              placeholder="اكتب رقم الموبايل"
            />
          </div>

          <!-- البريد الإلكتروني -->
          <div class="form-group">
            <label class="field-label">البريد الإلكتروني</label>
            <input
              class="input"
              type="email"
              formControlName="email"
              placeholder="اكتب البريد الإلكتروني"
            />
            <small class="error-text" *ngIf="isInvalid('email')">
              البريد الإلكتروني غير صحيح
            </small>
          </div>

          <!-- واتساب -->
          <div class="form-group">
            <label class="field-label">رقم الواتساب</label>
            <input
              class="input"
              type="text"
              formControlName="whatsapp_number"
              placeholder="اكتب رقم الواتساب"
            />
          </div>

          <!-- التخصص -->
          <div class="form-group">
            <label class="field-label">التخصص <span>*</span></label>
            <select class="input" formControlName="specialty">
              <option value="">اختر التخصص</option>
              <option *ngFor="let s of specialties" [value]="s.value">
                {{ s.label }}
              </option>
            </select>
            <small class="error-text" *ngIf="isInvalid('specialty')">
              التخصص مطلوب
            </small>
          </div>

          <!-- تخصص آخر -->
          <div class="form-group" *ngIf="data.value.specialty === 'Other'">
            <label class="field-label">تخصص آخر</label>
            <input
              class="input"
              type="text"
              formControlName="specialty_other"
              placeholder="اكتب التخصص"
            />
          </div>

          <!-- أعلى مؤهل -->
          <div class="form-group">
            <label class="field-label">أعلى مؤهل علمي <span>*</span></label>
            <select class="input" formControlName="highest_qualification">
              <option value="">اختر أعلى مؤهل علمي</option>
              <option *ngFor="let q of qualifications" [value]="q.value">
                {{ q.label }}
              </option>
            </select>
            <small class="error-text" *ngIf="isInvalid('highest_qualification')">
              أعلى مؤهل علمي مطلوب
            </small>
          </div>

          <!-- سنة الماجستير -->
          <div class="form-group">
            <label class="field-label">سنة الماجستير</label>
            <input
              class="input"
              type="number"
              formControlName="master_year"
              placeholder="مثال: 2020"
              min="1940"
              max="2100"
            />
            <small class="error-text" *ngIf="isInvalid('master_year')">
              سنة الماجستير يجب أن تكون بين 1940 و 2100
            </small>
          </div>

          <!-- سنة الدكتوراه -->
          <div class="form-group">
            <label class="field-label">سنة الدكتوراه</label>
            <input
              class="input"
              type="number"
              formControlName="phd_year"
              placeholder="مثال: 2024"
              min="1940"
              max="2100"
            />
            <small class="error-text" *ngIf="isInvalid('phd_year')">
              سنة الدكتوراه يجب أن تكون بين 1940 و 2100
            </small>
          </div>

          <!-- شهادات إضافية -->
          <div class="form-group full-row check-card">
            <label class="checkbox-label">
              <input
                type="checkbox"
                formControlName="has_additional_certificates"
              />
              <span>لديه شهادات إضافية</span>
            </label>
          </div>

          <div class="form-group full-row certificates-card" *ngIf="data.value.has_additional_certificates">
            <label class="field-label">اختر الشهادات الإضافية</label>

            <div class="checkbox-grid">
              <label *ngFor="let c of certificates" class="checkbox-label">
                <input
                  type="checkbox"
                  [checked]="selectedCertificates.includes(c.value)"
                  (change)="toggleCertificate(c.value, $event)"
                />
                <span>{{ c.label }}</span>
              </label>
            </div>
          </div>

          <!-- رفع ملفات الشهادات -->
          <div class="form-group full-row">
            <label class="field-label">رفع ملفات الشهادات</label>

            <input
              #certificateInput
              type="file"
              class="real-file-input"
              accept=".jpg,.jpeg,.png,.webp,.pdf,image/*,application/pdf"
              multiple
              (change)="onCertificateFilesSelected($event)"
            />

            <div class="custom-file-box" (click)="certificateInput.click()">
              <button type="button" class="file-btn">
                اختيار ملفات الشهادات
              </button>

              <span class="file-name">
                {{
                  selectedCertificateFiles.length
                    ? selectedCertificateFiles.length + ' ملف تم اختياره'
                    : 'لم يتم اختيار ملفات'
                }}
              </span>
            </div>

            <small class="hint">
              يمكنك رفع صور أو ملفات PDF بحد أقصى 20 ملف، وحجم كل ملف لا يزيد عن 5 ميجا.
            </small>

            <div class="selected-files" *ngIf="selectedCertificateFiles.length">
              <strong>الملفات المختارة:</strong>

              <div
                class="selected-file-row"
                *ngFor="let file of selectedCertificateFiles; let i = index"
              >
                <span>{{ file.name }}</span>

                <button
                  type="button"
                  class="remove-btn"
                  (click)="removeSelectedCertificateFile(i)"
                >
                  حذف
                </button>
              </div>
            </div>

            <div class="selected-files" *ngIf="isUpdatePage && existingCertificateFiles.length">
              <strong>ملفات الشهادات المرفوعة حاليًا:</strong>

              <div
                class="selected-file-row"
                *ngFor="let cert of existingCertificateFiles; let i = index"
              >
                <span>
                  {{ cert?.original_name || 'ملف شهادة رقم ' + (i + 1) }}
                </span>

                <a
                  class="open-file-btn"
                  [href]="getCertificateUrl(cert)"
                  target="_blank"
                  rel="noopener"
                >
                  فتح الملف
                </a>
              </div>
            </div>
          </div>

          <!-- حالة SCFHS -->
          <div class="form-group">
            <label class="field-label">حالة تصنيف SCFHS</label>
            <select class="input" formControlName="scfhs_status">
              <option value="">اختر حالة التصنيف</option>
              <option value="yes">مسجل ومصنف</option>
              <option value="in_progress">قيد الإجراء</option>
              <option value="no">غير مسجل</option>
            </select>
          </div>

          <!-- مستوى التصنيف -->
          <div
            class="form-group"
            *ngIf="data.value.scfhs_status && data.value.scfhs_status !== 'no'"
          >
            <label class="field-label">مستوى التصنيف</label>
            <select class="input" formControlName="scfhs_classification_level">
              <option value="">اختر مستوى التصنيف</option>
              <option *ngFor="let l of scfhsLevels" [value]="l.value">
                {{ l.label }}
              </option>
            </select>
          </div>

          <!-- تاريخ التصنيف -->
          <div
            class="form-group"
            *ngIf="data.value.scfhs_status && data.value.scfhs_status !== 'no'"
          >
            <label class="field-label">تاريخ التصنيف</label>
            <input
              class="input"
              type="date"
              formControlName="scfhs_classification_date"
            />
          </div>

          <!-- سنوات الخبرة -->
          <div class="form-group">
            <label class="field-label">سنوات الخبرة العملية</label>
            <select class="input" formControlName="years_of_practice">
              <option value="">اختر سنوات الخبرة</option>
              <option value="less_than_1">أقل من سنة</option>
              <option value="1_3">من سنة إلى 3 سنوات</option>
              <option value="4_7">من 4 إلى 7 سنوات</option>
              <option value="more_than_7">أكثر من 7 سنوات</option>
            </select>
          </div>

          <!-- نوع التوظيف -->
          <div class="form-group">
            <label class="field-label">نوع التوظيف المفضل</label>
            <select class="input" formControlName="preferred_employment_type">
              <option value="">اختر نوع التوظيف</option>
              <option value="full_time">دوام كامل</option>
              <option value="open">دوام كامل أو جزئي</option>
              <option value="part_time">دوام جزئي فقط</option>
            </select>
          </div>

          <!-- بيئة العمل -->
          <div class="form-group" *ngIf="isSurgerySpecialty()">
            <label class="field-label">بيئة العمل المفضلة</label>
            <select class="input" formControlName="preferred_practice_environment">
              <option value="">اختر بيئة العمل</option>
              <option value="hospital">مستشفى</option>
              <option value="dental_clinic">عيادة أسنان</option>
            </select>
          </div>

          <!-- السيرة الذاتية -->
          <div class="form-group full-row">
            <label class="field-label">رفع السيرة الذاتية PDF</label>

            <input
              #cvInput
              type="file"
              class="real-file-input"
              accept="application/pdf"
              (change)="onCvSelected($event)"
            />

            <div class="custom-file-box" (click)="cvInput.click()">
              <button type="button" class="file-btn">
                اختيار ملف السيرة الذاتية
              </button>

              <span class="file-name">
                {{ selectedCvFile ? selectedCvFile.name : 'لم يتم اختيار ملف' }}
              </span>
            </div>

            <small class="hint" *ngIf="isUpdatePage && existingCv">
              توجد سيرة ذاتية مرفوعة حاليًا
            </small>
          </div>

          <!-- رابط الأعمال -->
          <div class="form-group full-row">
            <label class="field-label">رابط الأعمال أو البورتفوليو</label>
            <input
              class="input"
              type="url"
              formControlName="portfolio_link"
              placeholder="اكتب رابط الأعمال إن وجد"
            />
          </div>

          <!-- ملاحظات -->
          <div class="form-group full-row">
            <label class="field-label">ملاحظات إضافية</label>
            <textarea
              class="input textarea"
              formControlName="additional_notes"
              placeholder="اكتب أي ملاحظات إضافية"
            ></textarea>
          </div>

          <!-- حفظ -->
          <div class="form-group full-row submit-row">
            <button
              type="submit"
              class="fromsave accont"
              [disabled]="data.invalid"
            >
              {{ isUpdatePage ? 'تحديث التسجيل' : 'إرسال التسجيل' }}
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>